import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'cityads-v3/types/reducer'

import {
  loadWebmasterInfo,
  loadWebmasterAdditionalData,
} from 'cityads-v3/actions/welcomeform'

export function usePreloadWebmasterInfo() {
  const dispatch = useDispatch()

  const userId = useSelector((state: RootState) => state.auth.user?.id)

  useEffect(() => {
    if (userId) {
      dispatch(loadWebmasterInfo(userId))
    }
  }, [dispatch, userId])

  useEffect(() => {
    if (userId) {
      dispatch(loadWebmasterAdditionalData(userId))
    }
  }, [dispatch, userId])
}
